import React from 'react'

export const GreenCheckbox = ({ checked, onChange, className = '', ...rest }) => {
  return (
    <input
      type='checkbox'
      className={className}
      checked={!!checked}
      onChange={e => onChange && onChange(e.target.checked, e)}
      {...rest}
    />
  )
}

export default GreenCheckbox